/* Locale registry. To add a language (up to 10-15+):
   1. Add an entry here.
   2. Create src/locales/<code>/<namespace>.json files (copy from en/).
   That's it — bundles are lazy-loaded on demand (see config.ts). */

export interface LocaleMeta {
  code: string;
  /** Native name, shown in the language switcher. */
  label: string;
  dir: "ltr" | "rtl";
}

export const LOCALES: LocaleMeta[] = [
  { code: "en", label: "English", dir: "ltr" },
  { code: "es", label: "Español", dir: "ltr" },
  // Adding a language = add an entry here + a src/locales/<code>/<ns>.json folder.
  // RTL is fully supported — set dir: "rtl" (e.g. Arabic/Hebrew):
  // { code: "de", label: "Deutsch", dir: "ltr" },
  // { code: "ar", label: "العربية", dir: "rtl" },
];

export const DEFAULT_LOCALE = "en";

export const SUPPORTED_CODES = LOCALES.map((l) => l.code);

export function localeMeta(code: string): LocaleMeta {
  return LOCALES.find((l) => l.code === code) ?? LOCALES[0]!;
}

export function dirFor(code: string): "ltr" | "rtl" {
  return localeMeta(code).dir;
}
